// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Libya */
const LY = /^(?:9[1-6]\d{7})$/;

export default LY;
